// extracted by mini-css-extract-plugin
module.exports = {"container":"template2Column_container__qgrXg","spotlightArticle":"template2Column_spotlightArticle__KEMeM","articlesSection":"template2Column_articlesSection__V33i1"};